import Button from "../../../components/Buttons/Button";
import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { Line } from "../../../style";
import { GrUpdate } from "react-icons/gr";
import { useApi } from "../../../hooks/api";
import { BsArrowRight } from "react-icons/bs";
import { FiAlertCircle } from "react-icons/fi";
import { themeTypes } from "../../../interfaces";
import { useGlobal } from "../../../hooks/global";
import { AiFillCheckCircle } from "react-icons/ai";
import { ModalGeneric } from "../../../components/ModalGeneric";
import { ProgressStatic } from "../../../components/ProgressStatic";
import { WaveLoading } from "../../../components/Loadings/WaveLoading";
import { fail, inactiveItens, info, secondary, success } from "../../../theme";

interface IModalImport {
    open: boolean
    onClose: () => void
    onFinish: () => void
    theme: themeTypes
    franchise_id: string
}

export const ModalImport: React.FC<IModalImport> = (props) => {
    const { onClose, onFinish, open, theme, franchise_id } = props

    const { api } = useApi()
    const { notify } = useGlobal()

    const [steps, setSteps] = useState(1)
    const [finished, setFinished] = useState(false)
    const [fails_count, setFailsCount] = useState(0)
    const [exist_count, setExistCount] = useState(0)
    const [success_count, setSuccessCount] = useState(0)
    const [properties, setProperties] = useState<any[]>([])
    const [total_importeds, setTotalImporteds] = useState(0)

    const transformPlural = useCallback((word_single, word_plural, length) => {
        return length > 1 ? word_plural : word_single
    }, [])

    const handleFinishImport = useCallback(async () => {
        setFinished(true)
        onFinish()
    }, [])

    const searchPropertiesOfSuperlogic = useCallback(async () => {
        try {
            const result = await api.get(`/integrations/super_logica/get-properties`)
            setProperties(result.data)
            setSteps(2)
        } catch (err) {
            notify("Erro ao buscar imóveis da Superlógica! Verifique suas credenciais!", "error")
            onClose()
        }
    }, [franchise_id])

    const confirmImportProperty = useCallback(async () => {
        let success_importeds = 0
        let fail_importeds = 0
        let exists_importeds = 0

        setSteps(3)

        for (const property of properties) {
            try {
                const { data } = await api.post(`/integrations/super_logica/import-property`, { property })
                const { property_exist } = data
                if (property_exist) exists_importeds++
                else success_importeds++
            } catch (err) {
                fail_importeds++
            }
            setTotalImporteds((prev) => prev + 1)
        }

        setTotalImporteds((prev) => prev + 1) // +1 for finish

        if (properties.length === 0) handleFinishImport()

        setSuccessCount(success_importeds)
        setFailsCount(fail_importeds)
        setExistCount(exists_importeds)

    }, [franchise_id, properties])

    useEffect(() => { searchPropertiesOfSuperlogic() }, [])

    return (
        <ModalGeneric open={open} onClose={() => { }}>
            {steps === 1 && (
                <Container style={{ minHeight: 400 }} theme={theme}>
                    <div>Buscando imóveis da <b>Superlógica</b></div>
                    <div style={{ display: "flex", flex: 1 }}>
                        <WaveLoading />
                    </div>
                    <Button
                        style={{ padding: 8, fontSize: 14 }}
                        onClick={() => onClose()}
                        background={inactiveItens[theme]}
                        color="#FFF"
                        children="Cancelar"
                    />
                </Container>
            )}
            {steps === 2 && (
                <Container theme={theme}>
                    <div style={{ textAlign: "center" }}>
                        {transformPlural("Foi encontrado", "Foram encontrados", properties.length)} <b>{properties.length}</b> {transformPlural("imóvel", "imóveis", properties.length)} na <b>Superlógica</b>,
                        deseja confirmar a importação?
                    </div>
                    <ul>
                        <li style={{ fontSize: 14, opacity: 0.7 }}>
                            Imóveis com proprietários sem um <b>nome</b> ou sem um <b>CPF/CNPJ</b> não serão importados!
                        </li>
                        <li style={{ fontSize: 14, opacity: 0.7 }}>
                            Após a confirmação não será mais possível cancelar esta ação!
                        </li>
                    </ul>
                    <Line style={{ gap: 10, width: "100%" }}>
                        <Button
                            style={{ padding: 8, fontSize: 14 }}
                            onClick={() => confirmImportProperty()}
                            background={secondary[theme]}
                            color="#FFF"
                            children="Confirmar"
                        />
                        <Button
                            style={{ padding: 8, fontSize: 14 }}
                            onClick={() => onClose()}
                            background={inactiveItens[theme]}
                            color="#FFF"
                            children="Cancelar"
                        />
                    </Line>
                </Container>
            )}
            {steps === 3 && !finished && (
                <Container theme={theme}>
                    <div style={{ textAlign: "center" }}>
                        Importando <b>{properties.length}</b> {transformPlural("imóvel", "imóveis", properties.length)} da <b>Superlógica</b>
                    </div>
                    <ProgressStatic
                        onFinished={handleFinishImport}
                        theme={theme}
                        max={properties.length}
                        min={0}
                        atual={total_importeds}
                    />
                    <div style={{ fontSize: 14, textAlign: "center", opacity: 0.7 }}>
                        Esta operação pode demorar alguns minutos! Permaceça nesta tela até o fim da importação!
                    </div>
                </Container>
            )}
            {steps === 3 && finished && (
                <Container theme={theme}>
                    <div style={{ textAlign: "center", fontWeight: 600 }}>
                        Resumo das importações
                    </div>
                    <table style={{ marginTop: -10 }}>
                        <tbody>
                            <tr>
                                <td>
                                    <AiFillCheckCircle color={success} />
                                </td>
                                <td style={{ padding: 10, whiteSpace: "nowrap" }}>
                                    Imóveis importados
                                </td>
                                <td style={{ padding: 10 }}>
                                    <BsArrowRight />
                                </td>
                                <td style={{ padding: 10, width: "100%", fontWeight: 600, color: success }}>
                                    {success_count}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <FiAlertCircle color={fail} />
                                </td>
                                <td style={{ padding: 10, whiteSpace: "nowrap" }}>
                                    Imóveis não importados
                                </td>
                                <td style={{ padding: 10 }}>
                                    <BsArrowRight />
                                </td>
                                <td style={{ padding: 10, width: "100%", fontWeight: 600, color: fail }}>
                                    {fails_count}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <GrUpdate color={info} />
                                </td>
                                <td style={{ padding: 10, whiteSpace: "nowrap" }}>
                                    Imóveis atualizados
                                </td>
                                <td style={{ padding: 10 }}>
                                    <BsArrowRight />
                                </td>
                                <td style={{ padding: 10, width: "100%", fontWeight: 600, color: info }}>
                                    {exist_count}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <Button
                        style={{ padding: 8, fontSize: 14 }}
                        onClick={() => onClose()}
                        background={inactiveItens[theme]}
                        color="#FFF"
                        children="Fechar"
                    />
                </Container>
            )}
        </ModalGeneric>
    )
}